import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import { generate } from "shortid";
import config from "../../../config/aws-exports";
import { API } from "aws-amplify";
import { Constants } from "../../../config/constants";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import moment from "moment";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import Backdrop from "@material-ui/core/Backdrop";

import AssessmentAndAssignmentView from "../AssessmentAndAssignmentView/AssessmentAndAssignmentView";
import { useSelector } from "react-redux";
import { authData, awsSignIn } from "../../../redux/auth/authSlice";
import { useDispatch } from "react-redux";
import { ReactComponent as Edit } from "../../../assets/svg/edit_black_24dp.svg";
import { ReactComponent as Delete } from "../../../assets/svg/delete_black_24dp.svg";
import Assess from "./AssessmentAndAssignmentList.module.scss";
import DeleteAssesAndAssign from "./DeleteAssessmentAndAssignement";
import EditAssesAndAssign from "./EditAssessmentAndAssignment";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  // console.log(props);

  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles({
  table: {
    minWidth: 500,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
  },
});

export default function AssessmentAndAssignmentList({ list, type, courseId }) {
  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [firstViewData, setFirstViewData] = React.useState({});
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const [assessId, setAssessId] = React.useState(0);
  const [instructions, setInstructions] = React.useState([]);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [instructionsView, setInstructionsView] = React.useState(true);
  const [questions, setQuestions] = React.useState([]);
  const [imgUrl, setImgUrl] = React.useState("");
  const [qLoading, setQLoading] = React.useState(false);
  const userDeatils = useSelector(authData);
  const dispatch = useDispatch();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  var timeNow = new Date().getTime();

  // console.log(list);
  let rows = [...list];

  //   JSON.parse(JSON.stringify(assessment));
  // console.log(rows);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDelete = (assess) => {
    setOpenDelete(true);
    setAssessId(assess);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleOpenEdit = () => {
    setOpenEdit(true);
    setAssessId();
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const handleClickOpen = (scrollType, assessId, instructions) => () => {
    setOpen(true);
    setScroll(scrollType);
    setAssessId(assessId);
    setInstructions(instructions);
    setInstructionsView(true);
    getQuiz(assessId);
  };
  const handleClose = () => {
    setOpen(false);
  };

  async function getQuiz(id) {
    setQLoading(true);
    const bodyParam = {
      body: {
        assessid: courseId,
        quizid: id,
        oid: config.aws_org_id,
        type: "assessmentdetails",
        quiztype: type == "Assessment" ? "assess" : "assign",
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      // console.log(JSON.stringify(bodyParam.body));

      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_ASSESMENT,
        bodyParam
      );
      console.log("response" + JSON.stringify(response));
      const { qitems } = response;
      setQuestions(qitems);
      // setQLoading(false);
      let ques = { ...userDeatils };
      if (response.qitems === undefined || response === undefined) {
        ques.questions = [];
        dispatch(awsSignIn(ques));
      } else {
        ques.questions = qitems;
        dispatch(awsSignIn(ques));
      }

      const imgUrl = `https://${
        config.DOMAIN
      }/${config.aws_org_id.toLowerCase()}-resources/images/${type.toLowerCase()}-images/${courseId}/${id}/`;
      setImgUrl(imgUrl);

      setQLoading(false);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="custom pagination table">
        <TableBody>
          {(rowsPerPage > 0
            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : rows
          ).map((row, indx) => (
            <TableRow key={generate() + row.title}>
              <TableCell
                component="th"
                scope="row"
                style={{ fontSize: "1.5rem", cursor: "pointer" }}
                onClick={handleClickOpen(
                  "body",
                  row.assessid,
                  row.instructions
                )}
              >
                {row.title}
                {type === "Assessment" && (
                  <>
                    <p>
                      Start Date :{" "}
                      {moment(row.startdate).format("MMMM Do YYYY, h:mm:ss a")}
                    </p>
                    <p>
                      End Date :{" "}
                      {moment(row.enddate).format("MMMM Do YYYY, h:mm:ss a")}
                    </p>
                  </>
                )}
              </TableCell>
              {type === "Assessment" ? (
                row.startdate > timeNow ? (
                  <>
                    <TableCell>
                      <Edit
                        className={Assess.icon}
                        onClick={() => {
                          handleOpenEdit();
                          firstViewData.title = row.title;
                          firstViewData.date = row.startdate;
                          firstViewData.dTEnd = row.enddate;
                          firstViewData.ansTime = row.answerdate;
                          firstViewData.ansDate = row.answerdate;
                          firstViewData.dTAns = row.answerdate;
                          firstViewData.sTime = row.startdate;
                          firstViewData.eTime = row.enddate;
                          firstViewData.id = row.assessid;
                          firstViewData.instructions = row.instructions;
                          setFirstViewData(firstViewData);
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Delete
                        className={Assess.icon}
                        onClick={() => {
                          handleOpenDelete(row.assessid);
                        }}
                      />
                    </TableCell>{" "}
                  </>
                ) : null
              ) : (
                <TableCell>
                  <Delete
                    className={Assess.icon}
                    onClick={() => {
                      handleOpenDelete(row.assessid);
                    }}
                  />
                </TableCell>
              )}
            </TableRow>
          ))}

          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: false,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openDelete}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openDelete}>
          <DeleteAssesAndAssign
            handleCloseDelete={handleCloseDelete}
            type={type}
            getQuiz={getQuiz}
            courseId={courseId}
            assessId={assessId}
          />
        </Fade>
      </Modal>
      <EditAssesAndAssign
        openEdit={openEdit}
        setOpenEdit={setOpenEdit}
        getQuiz={getQuiz}
        assessId={assessId}
        instructions={instructions}
        type={type}
        questions={questions}
        imgUrl={imgUrl}
        fullScreen={fullScreen}
        setInstructionsView={setInstructionsView}
        instructionsView={instructionsView}
        courseId={courseId}
        qLoading={qLoading}
        firstViewData={firstViewData}
        setFirstViewData={setFirstViewData}
      />
      <AssessmentAndAssignmentView
        open={open}
        handleClose={handleClose}
        scroll={scroll}
        assessId={assessId}
        instructions={instructions}
        type={type}
        questions={questions}
        imgUrl={imgUrl}
        getQuiz={getQuiz}
        fullScreen={fullScreen}
        setInstructionsView={setInstructionsView}
        instructionsView={instructionsView}
        courseId={courseId}
        qLoading={qLoading}
      />
    </TableContainer>
  );
}
